import { Address } from 'viem';

export const NFT_BONDS: Address = '0xb121CEc9f78366bB1bb08E3f26d4b25743C61546';
export const NFT_REDEMPTION: Address =
  '0xe28603Dce858d3378d4aa2620b18d67B86d629C1';
export const REWARD_POOL: Address =
  '0xb98c0b7da25846050695262F1Fe3707C8E76d7BB';
